// @flow
import React, { Component } from 'react';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import { StyleSheet, View } from 'react-native';
import { FullButton, GradientPage } from '../../../components/common';
import { LoginForm, PageTitle } from '../../../components/signUp';
import I18n from '../../../lib/i18n';
import PasswordService from '../../../lib/password';

export default class ResetPasswordConfirmation extends Component<Props, {passwordProgress: number}> {
  styles = getStyles();
  state = { passwordProgress: 0 };

  render() {
    const styles = this.styles;
    return (
      <GradientPage maxWidth={600}>
        <View style={styles.container}>
          <View style={styles.title}>
            <PageTitle title={I18n.t('Login.ResetPasswordConfirmation.title')} />
          </View>
          <LoginForm
            handleSubmit={this.props.handleSubmit}
            withPasswordStrength
            withoutEmailField
            autoFocus
            onPasswordStrengthChange={(progress) => this.setState({ passwordProgress: progress })}
          />
          <FullButton
            onPress={this.props.handleSubmit}
            text={I18n.t('Login.ResetPasswordConfirmation.confirm')}
            style={styles.button}
            isLoading={this.props.isLoading}
            disabled={this.state.passwordProgress < PasswordService.MIN_PROGRESS_TO_SUBMIT}
          />
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      marginHorizontal: 22,
    },
    title: {
      marginVertical: 20,
    },
    button: {
      marginTop: 20,
      marginBottom: 30,
    },
  });

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
  handleSubmit: Function,
  isLoading: boolean,
};
